var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomationCompletedFailed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C53DCB85-9930-41F6-A46E-EB3C7ACC6EE0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.63447791,8.58654088 C2.11119841,9.30689967 1.54714389,11.1010008 2.40002151,11.7216873 C3.25289914,12.3412412 4.72080007,11.204071 5.24521221,10.4825796 C5.24521221,10.4825796 5.69600277,9.85056668 6.20908852,9.85056668 C6.72217426,9.85056668 7.17296482,10.4825796 7.17296482,10.4825796 C7.69624432,11.204071 9.16414526,12.3412412 10.0170229,11.7216873 C10.8710331,11.1010008 10.3069786,9.30689967 9.78369912,8.58654088 C9.78369912,8.58654088 9.32044952,7.96245645 9.47901907,7.47428878 C9.63758861,6.98498847 10.3783349,6.75279735 10.3783349,6.75279735 C11.2255493,6.47756592 12.6968482,5.47971043 12.370648,4.47732438 C12.0444478,3.47380568 10.2288265,3.40471467 9.38161206,3.68447665 C9.10751328,3.77395518 8.64539632,3.93139208 8.22971758,3.63010995 C7.81517148,3.32769517 7.82309996,2.5507044 7.82309996,2.5507044 C7.82309996,1.66044967 7.26357599,0 6.20908852,0 C5.15460104,0 4.59620971,1.66044967 4.59620971,2.5507044 C4.59620971,2.5507044 4.60413819,3.32769517 4.18845945,3.63010995 C3.77164808,3.93139208 3.03543233,3.68447665 3.03543233,3.68447665 C2.1882179,3.40924522 0.372596611,3.47380568 0.0463964033,4.47732438 C-0.279803804,5.47971043 1.19149505,6.47756592 2.03870948,6.75279735 C2.03870948,6.75279735 2.77945578,6.98498847 2.93915797,7.47428878 C3.09772751,7.96245645 2.63447791,8.58654088 2.63447791,8.58654088 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2148448,10 C10.4911053,10 10.7489484,9.85576923 10.8901481,9.62139423 C11.0313479,9.38701923 11.037487,9.09855769 10.9024264,8.86418269 L6.18758154,0.402644231 C6.05252088,0.15625 5.78853868,0 5.5,0 C5.21146132,0 4.94747912,0.15625 4.81241846,0.402644231 L0.0975736241,8.86418269 C-0.0374870353,9.09855769 -0.0313479144,9.38701923 0.109851866,9.62139423 C0.251051646,9.85576923 0.508894723,10 0.785155163,10 L10.2148448,10 Z M6.06479912,6.15384615 L4.92906176,6.15384615 C4.81241846,6.15384615 4.72033165,6.09375 4.72033165,6.015625 L4.61596659,3.26923077 C4.61596659,3.23317308 4.63438396,3.17307692 4.6773578,3.14302885 C4.71419253,3.11298077 4.76944462,3.07692308 4.8246967,3.07692308 L6.1753033,3.07692308 C6.23055538,3.07692308 6.28580747,3.11298077 6.3226422,3.14302885 C6.36561604,3.17307692 6.38403341,3.22115385 6.38403341,3.25721154 L6.27352923,6.015625 C6.26739011,6.09375 6.1753033,6.15384615 6.06479912,6.15384615 Z M6.0893556,8.46153846 L4.9106444,8.46153846 C4.80014022,8.46153846 4.71419253,8.37139423 4.71419253,8.26322115 L4.71419253,7.12139423 C4.71419253,7.01322115 4.80014022,6.92307692 4.9106444,6.92307692 L6.0893556,6.92307692 C6.19985978,6.92307692 6.28580747,7.01322115 6.28580747,7.12139423 L6.28580747,8.26322115 C6.28580747,8.37139423 6.19985978,8.46153846 6.0893556,8.46153846 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Case-Table",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Monitor_Case-Queue",
    transform: "translate(-577.000000, -858.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(560.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(15.366667, 43.200000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(2.487881, 563.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-1",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Status/6-Online",
    mask: "url(#mask-2)",
    fill: "#2CB470"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.790911, -0.636364)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 14,
    height: 14
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-Copy",
    transform: "translate(5.145452, 6.300000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#FFFFFF",
    points: "4.39986429 2.76923847 6.60012259 2.76923847 7.70025174 9.23076923 3.29973514 9.23076923"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uF071"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#EF5353",
    xlinkHref: "#path-3"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationCompletedFailed);
export default __webpack_public_path__ + "static/media/automation-completed-failed.44d3ae573ab4972bc35df470023ae9f9.svg";
export { ForwardRef as ReactComponent };